module.exports = __webpack_public_path__ + "img/upload_wall_8.6645d6c3.webp";